module.exports = {"532823101":"勐腊镇","532823102":"勐捧镇","532823103":"勐满镇","532823104":"勐仑镇","532823105":"磨憨镇","532823106":"勐伴镇","532823107":"关累镇","532823108":"易武镇","532823202":"象明彝族乡","532823203":"瑶区瑶族乡","532823401":"勐腊农场","532823402":"勐捧农场","532823403":"勐满农场","532823404":"勐醒农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532823.json
// module id = 2647
// module chunks = 0